









































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ModalDelete from '@/app/ui/components/ModalDelete/index'
import ModalDetail from './ModalDetail.vue'
import { UserModule } from '@/app/store/modules/user'
import moment from 'moment'
import { MasterModule } from '@/app/store/modules/master'
import { AuthModule } from '@/app/store/modules/auth'
import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from 'vuelidate/lib/validators'

@Component({
  components: {
    'modal-delete': ModalDelete,
    'modal-detail': ModalDetail,
  },
})
export default class extends Vue {
  @Prop({}) public dataTable
  @Prop({}) public fields: any[] | undefined
  @Prop({}) public selected: any[] | undefined
  @Prop({}) public storageType: string | undefined

  public modalDetail = 'modalDetail'
  public detail: any = {}
  public typeMenu = 'User'

  // Validate
  public $v: Vuelidate
  @Validate({
    sameAsPassword: sameAs('password'),
  })
  public passwordConfirm: string = ''

  @Validate({})
  public password: string = ''

  @Validate({})
  public email: string = ''

  @Validate({})
  public phoneNumber: string = ''

  // FIlter By Position
  public position: string = ''
  public positionId: string = ''
  public byPosition(text) {
    const find = this.positionOptions.find((e) => e.description === text)
    const index = this.positionOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getPosition()
    }
    if (this.positionOptions.length > 0) {
      this.positionId = this.positionOptions.find(
        (e) => e.description === text
      ).id
    }
  }
  public positionOptions: any = []
  public get positionCode() {
    this.positionOptions = MasterModule.PositionData.data
    return MasterModule.PositionData
  }

  // Option for grade
  public optionsGradeLastYear: any = [
    { text: 'New', value: 1 },
    { text: 'Regular', value: 2 },
    { text: 'Silver', value: 3 },
    { text: 'Gold', value: 4 },
  ]
  public optionsGradeExisting: any = [
    { text: 'New', value: 1 },
    { text: 'Regular', value: 2 },
    { text: 'Silver', value: 3 },
    { text: 'Gold', value: 4 },
  ]
  // Option for statusEmployee
  public optionsStatusEmployee: any = [
    { text: 'Active', value: true },
    { text: 'Inactive', value: false },
  ]
  // Option for level
  public optionsLevel: any = [
    {
      value: 2,
      text: 'Trainee',
    },
    {
      value: 3,
      text: 'Junior',
    },
    {
      value: 4,
      text: 'Senior',
    },
  ]

  @Validate({
    required,
  })
  // FIlter By Dealer Group
  public dealerGroup: string = ''
  public dealerGroupId: string = ''
  public byDealerGroup(text) {
    const find = this.dealerGroupOptions.find((e) => e.name === text)
    const index = this.dealerGroupOptions.indexOf(find)
    if (text.length >= 3 && index === -1) {
      MasterModule.paginationParam.search = text
      MasterModule.getDealerGroup()
    }
    if (this.dealerGroupOptions.length > 0) {
      this.dealerGroupId = this.dealerGroupOptions.find(
        (e) => e.name === text
      ).id
    }
  }
  public dealerGroupOptions: any = []
  public get dealerGroupCode() {
    this.dealerGroupOptions = MasterModule.DealerGroupData.data
    return MasterModule.DealerGroupData
  }

  public modalDelete = {
    id: 'modal-delete',
    idCategory: 0,
    categoryName: '',
  }
  // Initial for changePassword
  public sales_type: string = '/MMKSI/gi'
  public showstatus: string = 'true'
  public iconType: string = 'lock'
  public disable: boolean = true
  public passwordType: string = 'password'
  public passwordTypeConfirm: string = 'password'
  public iconTypepassword: string = 'eye-slash'
  public iconTypeConfirmpasssword: string = 'eye-slash'
  public changeShowStatus() {
    if (this.showstatus === 'true') {
      this.disable = false
      this.showstatus = 'false'
      this.iconType = 'unlock'
    } else {
      this.disable = true
      this.showstatus = 'true'
      this.iconType = 'lock'
    }
  }
  public changePasswordType() {
    if (this.passwordType === 'password') {
      this.passwordType = 'text'
      this.iconTypepassword = 'eye'
    } else {
      this.passwordType = 'password'
      this.iconTypepassword = 'eye-slash'
    }
  }

  public name: string = 'profile'
  public data: string = ''
  public array: any = []
  public contains(data) {
    this.array = this.data.split('/')
    return this.array.indexOf(name) > -1
  }

  public changePasswordTypeConfirm() {
    if (this.passwordTypeConfirm === 'password') {
      this.passwordTypeConfirm = 'text'
      this.iconTypeConfirmpasssword = 'eye'
    } else {
      this.passwordTypeConfirm = 'password'
      this.iconTypeConfirmpasssword = 'eye-slash'
    }
  }

  public userData: any = {
    id: 0,
    code: '',
    name: '',
    email: '',
    phoneNumber: '',
    password: '',
    Confirmpassword: '',
    joinDate: '',
    dealerGroup: '',
    supervisorName: '',
    position: '',
    Notes: '',
    gradeLastYear: 'Select Grade Last Year',
    statusEmployee: 'Select Status Employee',
    dealerBranch: '',
    level: 'Select Level',
    gradeExisting: 'Select Grade Existing',
    dealerBranchId: 0,
    dealerName: 'Select Dealer Name',
    dealerCity: 'Select Dealer City',
  }
  public $refs!: {
    selectableTable: HTMLFormElement
  }
  public selectMode = 'multi'
  public perPage = 3

  public formDisabled: boolean = false

  public detailUser(item, index, button) {
    //  console.log(item)
    this.detail = item
    this.$root.$emit('bv::show::modal', 'modalDetail', button)
  }

  public selectedDealerGroup: any = []

  public getSelectedDealerGroup() {
    if (this.dealerGroupOptions) {
      this.selectedDealerGroup = []
      const id = parseInt(this.dealerGroup.split('/')[1], 10)

      for (const item of this.dealerGroupOptions) {
        if (item.id === id) {
          this.selectedDealerGroup.push(item)
        }
      }
      //  console.log('string', this.selectedDealerGroup)
    }
  }

  public get buttonDisable(): boolean {
    if (this.$props.selected.length < 1) {
      return false
    } else {
      return true
    }
  }

  public get needSalesCode() {
    const powerUser = AuthModule.salesCode.role
    if (powerUser !== 'Super Admin') {
      return true
    }
    return false
  }

  public setDisabled(item) {
    if (item.dataStorage === 'Dnet') {
      this.formDisabled = true
    } else {
      this.formDisabled = false
    }
  }
  public oldBranchName: string = ''

  public funcEditDnet(item, index, button) {
    //  console.log('item', item)
    const splitDate = item.salesman.salesman_hire_date.split('T')
    if (this.$props.selected.length < 1) {
      this.oldBranchName = item.salesman.dealer_branch_name
      this.setDisabled(item)
      this.userData.dealerBranchId = item.salesman.dealer_branch_id
      this.userData.positionId = item.salesman.job_position_id
      this.userData.id = item.id
      this.userData.code = item.salesman.salesman_code
      this.userData.name = item.salesman.salesman_name
      this.userData.email = item.email
      this.userData.phoneNumber = item.phone
      this.userData.password = item.password
      this.userData.joinDate = splitDate[0]
      this.userData.supervisorName = item.salesman.superior_name
      this.userData.position = item.salesman.job_description
      this.userData.gradeLastYear = item.grade.last_year
      this.userData.statusEmployee = item.isActive
      this.userData.dealerBranch = item.salesman.dealer_branch_name
      this.userData.level =
        item.salesman.level_description === 'Trainee'
          ? '2'
          : item.salesman.level_description === 'Junior'
          ? '3'
          : item.salesman.level_description === 'Senior'
          ? '4'
          : ''
      this.userData.gradeExisting = item.grade.current_year
      this.userData.dealerName = item.salesman.dealer_name
      this.userData.dealerCity = item.salesman.dealer_city
      this.$root.$emit('bv::show::modal', 'editUserDnet', button)
    }
  }

  public funcEdit(item, index, button) {
    //  console.log('item', item)
    if (this.$props.selected.length < 1) {
      this.oldBranchName = item.salesman.dealer_branch_name
      this.setDisabled(item)
      this.userData.dealerBranchId = item.salesman.dealer_branch_id
      this.userData.positionId = item.salesman.job_position_id
      this.userData.id = item.id
      this.userData.dealerGroup = item.salesman.dealer_group
      this.userData.notes = item.salesman.notes
      this.userData.code = item.salesman.salesman_code
      this.userData.name = item.salesman.salesman_name
      this.userData.email = item.email
      this.userData.phoneNumber = item.phone
      this.userData.password = item.password
      this.userData.position = item.salesman.job_description
      this.userData.statusEmployee = item.isActive
      this.$root.$emit('bv::show::modal', 'editUser', button)
    }
  }

  public get stateConfirm(): boolean {
    return this.passwordConfirm.length >= 6 &&
      this.passwordConfirm === this.password
      ? true
      : false
  }
  public get invalidConfirm(): string {
    if (this.passwordConfirm.length >= 6) {
      return 'Your Passowrd Not Match'
    } else if (this.passwordConfirm.length > 0) {
      return 'Enter at least 6 characters'
    } else {
      return ''
    }
  }
  public funcDelete(item, index, button) {
    //  console.log('user delete', item)
    if (this.$props.selected.length < 1) {
      this.modalDelete.categoryName = item.salesman.salesman_name
      this.modalDelete.idCategory = item.id
      this.$root.$emit('bv::show::modal', this.modalDelete.id, button)
    }
  }
  public resetEditModal() {
    this.userData.code = ''
    this.userData.email = ''
    this.userData.password = ''
    this.userData.position = ''
    this.userData.statusEmployee = 'Select Status Employee'
    this.userData.notes = ''
    this.userData.name = ''
    this.userData.phoneNumber = ''
    this.userData.passwordConfirm = ''
    this.userData.dealerGroup = ''
  }
  public resetDeleteModal() {
    this.modalDelete.idCategory = 0
    this.modalDelete.categoryName = ''
  }
  public onRowSelected(items) {
    this.$emit('onRowSelected', items)
  }
  public selectAllRows() {
    if (this.$props.selected.length === this.dataTable.data.length) {
      this.$refs.selectableTable.clearSelected()
    } else {
      this.$refs.selectableTable.selectAllRows()
    }
  }
  public deleteNotif() {
    const ids = [this.modalDelete.idCategory]
    UserModule.deleteUser({ ids })
    this.$root.$emit('bv::hide::modal', 'modal-delete')
  }

  public patchUser(item, index, button) {
    this.$v.password.$touch()
    this.$v.passwordConfirm.$touch()
    if (this.$v.password.$invalid || this.$v.passwordConfirm.$invalid) {
      return
    } else {
      const DataToUpdate = {
        id: this.userData.id,
        salesmanName: this.userData.name,
        email: this.userData.email,
        password: this.password,
        phone: this.userData.phoneNumber,
        notes: this.userData.notes,
        dealerGroup: this.userData.dealerGroup,
        position: this.userData.position,
        isActive: this.userData.statusEmployee,
      }
      UserModule.updateUser(DataToUpdate)
      this.$root.$emit('bv::hide::modal', 'edit-User', button)
    }
  }

  public patchUserDnet(item, index, button) {
    this.$v.password.$touch()
    this.$v.passwordConfirm.$touch()
    if (
      this.disable === true ||
      this.$v.password.$invalid ||
      this.$v.passwordConfirm.$invalid
    ) {
      return
    } else {
      const DataToUpdate = {
        salesCode: this.userData.code,
        password: this.password,
        email: this.userData.email,
        phoneNumber: this.userData.phoneNumber,
      }
      UserModule.updateUserDnet(DataToUpdate)
      this.$root.$emit('bv::hide::modal', 'edit-User', button)
    }
  }
}
